export default __webpack_public_path__ + "static/media/left-quotes-sign.fb626ea7.svg";